'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Device = function Device(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-device ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M6,2 L20,2 C21.1045695,2 22,2.8954305 22,4 L22,22 C22,23.1045695 21.1045695,24 20,24 L6,24 C4.8954305,24 4,23.1045695 4,22 L4,4 C4,2.8954305 4.8954305,2 6,2 Z M6,4 L6,20 L20,20 L20,4 L6,4 Z M13,23 C13.5522847,23 14,22.5522847 14,22 C14,21.4477153 13.5522847,21 13,21 C12.4477153,21 12,21.4477153 12,22 C12,22.5522847 12.4477153,23 13,23 Z' })
  );
};

Device.propTypes = _bcPropTypes.iconShape;

exports.default = Device;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Device/Device.js
// module id = 208
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16